module.exports = __webpack_public_path__ + "static/img/W.a2135e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/W.png
// module id = x1X1
// module chunks = 0